import React, {useEffect, useMemo} from "react";
import MapContent from "./map-content.jsx";
import ReportUtils from "../../../../../utils/report-utils.js";
import {useQuery} from "@tanstack/react-query";
import CorporationService from "../../../../../services/web/corporation-service.js";
import {APIProvider, ControlPosition, Map as GoogleMaps} from "@vis.gl/react-google-maps";

const ReportContent = ({ data, showLayer, mapMode, mapImage }) => {
    const coordinates = data?.result?.coordinates ?? [];
    const layers = data?.layer ?? [];

    const { data: corporation } = useQuery({
        queryKey: ['corporation'],
        queryFn: () => CorporationService.entity(),
    });

    const position = useMemo(() => {
        if (coordinates.length) {
            return {
                lat: parseFloat(coordinates[0].latitude),
                lng: parseFloat(coordinates[0].longitude),
            };
        }

        return {lat: -23.0, lng: -46.0};
    }, [coordinates]);

    useEffect(() => {
        const labels = ["Latitude", "Longitude", "Data/hora"];

        const values = coordinates.map((el) => [
            el.latitude,
            el.longitude,
            el.device_time,
        ]);

        ReportUtils.createExportableTable(labels, values, "Localização da guarnição");
    }, [coordinates]);

    return (
        <>
            { corporation && !mapImage && (
                <div className="print:hidden relative">
                    <APIProvider apiKey={corporation?.maps_api_key ?? ""} language="pt-BR" libraries={["places"]}>
                        <GoogleMaps
                            id={'map-report-component'}
                            ref={(map) => {
                                if (map && map.map) {
                                    const div = map.map.getDiv();
                                    div.__google_map_instance = map.map;
                                }
                            }}
                            defaultZoom={18}
                            defaultCenter={position}
                            streetViewControl={false}
                            scrollwheel={true}
                            gestureHandling={'greedy'}
                            renderingType="RASTER"
                            style={{ height: "644px", width: "100%" }}
                            fullscreenControlOptions={{position: ControlPosition.BOTTOM_RIGHT}}
                            mapTypeControlOptions={{position: ControlPosition.TOP_RIGHT}}
                        >
                            <MapContent coordinates={coordinates} layers={layers} showLayer={showLayer} mapMode={mapMode}/>
                        </GoogleMaps>
                    </APIProvider>
                </div>
            )}

            <div id="chart-tables"></div>
        </>
    );
};

export default ReportContent;